import { styled } from 'styled-components';
import { Row } from 'react-bootstrap';

import { api } from 'common';

import { updateWindowHistory } from '../../Common/utils';

export interface FilterProps {
  filterOptions: api.PrevisitProvider.FilterOptions;
  setFilterOptions: (value: api.PrevisitProvider.FilterOptions) => void;
  pathname: string;
  organizationId: string;
  params: URLSearchParams | undefined;
  embedded: boolean | null;
  setCurrentPage?: (value: number) => void;
}

export const RowWithPadding = styled(Row)`
  padding-bottom: 8px;
`;

export const StyledRow = styled(Row)`
  > label {
    padding: 4px 0;
  }
`;

export const StyledHr = styled.hr`
  color: var(--color-shade-60) !important;
  margin-left: -12px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export function updateFilterParams(args: {
  checked: boolean;
  pathname: string;
  organizationId: string;
  params: URLSearchParams | undefined;
  embedded: boolean | null;
  paramString: string;
  filterItem: string;
}): string[] {
  const {
    checked,
    embedded,
    filterItem,
    organizationId,
    paramString,
    params,
    pathname,
  } = args;
  const filterParams = params?.getAll(paramString) ?? [];
  const updatedFilterParams: string[] = [];
  if (!checked) {
    if (filterParams.includes(filterItem)) {
      updatedFilterParams.push(
        ...filterParams.filter((filterParam) => filterParam !== filterItem),
      );
      if (params) {
        params.delete(paramString);
        updatedFilterParams.forEach((filterItem) =>
          params.append(paramString, filterItem),
        );
      }
    }
  } else if (!filterParams.includes(filterItem)) {
    params && params.append(paramString, filterItem);
    filterParams.push(filterItem);
    updatedFilterParams.push(...filterParams);
  }
  updateWindowHistory({
    pathname,
    organizationId,
    params,
    embedded,
  });
  return updatedFilterParams;
}
